/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import { ViewModalHeader } from './ViewModalHeader'
import axios from 'axios'
import Swal from 'sweetalert2'
import { useAuth } from '../../../auth'
import { useAppSelector } from '../../../../../redux/hooks'
import { getentitlements, getentitlementstenant, getcredentias } from '../../entitlements/request/request'
import { DemoModal } from '../../../../Modal_Demo/ViewModalDemo'
const API_URL = process.env.REACT_APP_API_URL


type Rol =
  {
    name: string
    description: string
    id: string
    Permissions: x[]
  }
type x =
  {
    id: string
    name: string
    description: string
  }

const DevicesForti = (props: any) => {

  const [ID, setID] = useState<ID>(undefined)
  type ID = undefined | null | number | string


  /*********************************Constantes**************************************** */
  const tenant = useAppSelector(state => state.TenantSlice.id)
  const Id = useAppSelector(state => state.SuscriptionSlice.id)
  const Type = useAppSelector(state => state.CloudSlice.Type)


  const { currentUser } = useAuth()
  const [selectedItems, setSelectedItems] = useState<number[]>([]);
  const [showModal, setShowModal] = useState(true); // Estado para controlar la visibilidad del modal

  const [IdPermiso, setIdPermiso] = useState<Rol>({
    name: '',
    description: '',
    id: '',
    Permissions: []

  })


  // eslint-disable-next-line
  const [loading, setLoading] = useState(false)

  ////
  const [Nombre, setNombre] = useState('');
  const [Memory, setMemory] = useState('');
  const [entitlement, setentitlement] = useState('');



  /******************************************************************* */
  const [Records, setRecords] = useState<any | null>([])
  useEffect(() => {
    if (currentUser?.ListPermiso?.includes('Ctx.NGFW.Add')) {
      if (tenant === 0) {
        getentitlements('Ctx.NGFW.Add').then(response => {
          if (response.data.length > 0) {
            setRecords(response.data)
          }
          else {
            setRecords([])
          }
        })
      }
      else if (tenant !== 0) {
        getentitlementstenant(tenant, 'Ctx.NGFW.Add').then(response => {
          if (response.data.length > 0) {
            setRecords(response.data)
          }
          else {
            setRecords([])
          }
        })
      }
    }
  }, [tenant])

  let Vcpu = ''

  for (const x of Records) {
    if (Number(entitlement) === x.id) {
      Vcpu = x.vcpu
    }
  }
  /**************************credentials************************** */
  const [credentials, setcredentials] = useState<any | null>([])

  useEffect(() => {
    if (currentUser?.ListPermiso?.includes('Ctx.NGFW.Update') && Id !== 0 && Type !== 'Global') {
      if (tenant === 0) {
        getcredentias(Id, props.fw).then(response => {
          if (response.data) {
            setcredentials(response.data)
          }
          else {
            setcredentials([])
          }
        })
      }
      else if (tenant !== 0) {
        getcredentias(Id, props.fw).then(response => {
          if (response.data) {
            setcredentials(response.data)
          }
          else {
            setcredentials([])
          }
        })
      }
    }
  }, [tenant])

  /**************************global poc */
  useEffect(() => {
    if (currentUser?.ListPermiso?.includes('Ctx.NGFW.Update') && Id === 0 && Type === 'Global') {
      if (tenant === 0) {
        getcredentias(19, props.fw).then(response => {
          if (response.data) {
            setcredentials(response.data)
          }
          else {
            setcredentials([])
          }
        })
      }
      else if (tenant !== 0) {
        getcredentias(19, props.fw).then(response => {
          if (response.data) {
            setcredentials(response.data)
          }
          else {
            setcredentials([])
          }
        })
      }
    }
  }, [tenant])
  /***********************Enviar Config Devices */

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    try {
      const permision = []
      for (const y of selectedItems) {
        permision.push({ id: y })
      }



      if (props.id !== null) {
        const actualizar = {
          name: IdPermiso.name,
          description: IdPermiso.description,
          id: IdPermiso.id,
          Permission: permision,
        }
        if (tenant === 0) {
          await axios.put(API_URL + '/v1/rol/' + props.id, actualizar)
            .then(res => {
              Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Your Role has Update',
                showConfirmButton: false,
                timer: 1500
              })
              window.location.reload();
            });
        }
        else {
          await axios.put(API_URL + '/v1/rol/' + props.id + '?tenantId=' + tenant, actualizar)
            .then(res => {
              Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Your Role has Update',
                showConfirmButton: false,
                timer: 1500
              })
              window.location.reload();
            });
        }

      }
      ///////////////////////
      else {
        let nameconfig
        let nivel
        let VDOM
        for (const x of Records) {
          if (Number(entitlement) === x.id) {
            nameconfig = x.name
            nivel = x.nivel
            VDOM = x.VDOM
          }
        }
        const body = {
          name: Nombre,
          ram: Number(Memory),
          configId: Number(entitlement),
          nameconfig: nameconfig,
          nivel: nivel,
          vcpu: Number(Vcpu),
          VDOM: Number(VDOM),
          SubscriptionId: Id

        }
        if (tenant === 0) {
          await axios.post(API_URL + '/v1/fw/newNgfw', body)
            .then(res => {
              Swal.fire({
                position: 'center',
                icon: 'info',
                title: 'Your device will be created.',
                showConfirmButton: false,
                timer: 1500

              })
              //window.location.reload();

            });
          props.setautoreload(true)
          setShowModal(false);

        }
        else {
          console.log(body)
          await axios.post(API_URL + '/v1/fw/newNgfw', body)
            .then(res => {
              Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Your Device has created',
                showConfirmButton: false,
                timer: 1500

              })
              //window.location.reload();

            });
          props.setautoreload(true)
          setShowModal(false);

        }
        //navigate('/support/SeeRequest')
      }
    }
    catch (error: any) {
      console.log(error)

    }


  }

  /////////////////////////////////////////////////////////
  const [showPassword, setShowPassword] = useState(false);
  const [showCopyNotification, setShowCopyNotification] = useState(false);

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  const handleCopyPassword = () => {
    navigator.clipboard.writeText(credentials.pass);
    setShowCopyNotification(true);
    setTimeout(() => {
      setShowCopyNotification(false);
    }, 2000); // Hides the notification after 2 seconds
  };




  return (

    <>

      {props.id === 'edit' &&
        <div>
          <div
            className='modal fade show d-block'
            id='kt_modal_add_user'
            role='dialog'
            tabIndex={-1}
            aria-modal='true'
          >
            {/* begin::Modal dialog */}
            <div className='modal-dialog modal-dialog-centered mw-650px'>
              {/* begin::Modal content */}
              <div className='modal-content'>
                <ViewModalHeader setID={props.setID} />
                {/* begin::Modal body */}
                <div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
                  <form className='form w-100' id='kt_login_signin_form' onSubmit={handleSubmit} >
                    {/* begin::Heading */}
                    <div className='text-center mb-5'>
                      <h1 className='text-marni f-titulo fw-bolder mb-3'>Edit Device</h1>
                    </div>
                    {/* begin::Heading */}



                    {/* Campos solicitud */}
                    <div>
                      <label className='form-label fw-bolder text-marino f-parrafo fs-6 mb-0' htmlFor="name">Name</label>
                      <input type="text" name='name' value={IdPermiso.name} className='form-control border-gray-300 f-parrafo'
                        onChange={(e: any) => setIdPermiso({ ...IdPermiso, name: e.target.value })} />
                    </div>
                    <br />
                    <div className='row'>
                      <div className='col'>
                        <label className='form-label fw-bolder text-marino f-parrafo fs-6 mb-0' htmlFor="apellido">VCPU</label>
                        <input type="text" name='apellido' value={IdPermiso.description} className='form-control border-gray-300 f-parrafo'
                          onChange={(e: any) => setIdPermiso({ ...IdPermiso, description: e.target.value })} />
                      </div>
                      <div className='col'>
                        <label className='form-label fw-bolder text-marino f-parrafo fs-6 mb-0' htmlFor="apellido">Memory</label>
                        <input type="text" name='apellido' value={IdPermiso.description} className='form-control border-gray-300 f-parrafo'
                          onChange={(e: any) => setIdPermiso({ ...IdPermiso, description: e.target.value })} />
                      </div>
                    </div>

                    <br />
                    <div>
                      <label className='form-label fw-bolder text-marino f-parrafo fs-6 mb-0 required form-label'>Entitlement</label>
                      <select
                        required
                        id='Prioridad'
                        value={entitlement}
                        onChange={(e) => setentitlement(e.target.value)}

                        className="form-select form-select-solid  border-gray-300 f-parrafo " aria-label="Select example">
                        <option selected hidden>Select</option>
                        <option className="text-success" value="1">Low</option>
                        <option className="text-warning" value="2">Medium</option>
                        <option className="text-danger" value="3">High</option>
                        <option className="text-light-danger bg-danger" value="4">Urgent</option>
                      </select>
                    </div>


                    <br />
                    {/* begin::Action */}
                    <div className='d-grid mb-10'>
                      <div className='row'>
                        <div className='col'>
                          <button
                            type='submit'
                            id='kt_sign_in_submit'
                            className='btn btn-primary'
                          >
                            {!loading && <span className='indicator-label'>Save</span>}
                            {loading && (
                              <span className='indicator-progress' style={{ display: 'block' }}>
                                Please wait...
                                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                              </span>
                            )}
                          </button>
                        </div>
                        <div className='col'>
                          <button
                            id='kt_sign_in_submit'
                            className='btn btn-primary'
                            onClick={() => props.setID(undefined)}

                          >
                            Cancel
                          </button>
                        </div>


                      </div>


                    </div>
                    {/* end::Action */}


                  </form>

                </div>
                {/* end::Modal body */}
              </div>
              {/* end::Modal content */}
            </div>
            {/* end::Modal dialog */}
          </div>
          {/* begin::Modal Backdrop */}
          <div className='modal-backdrop fade show'></div>
          {/* end::Modal Backdrop */}
        </div>
      }


      {showModal && props.id === null &&
        <div>
          <div
            className='modal fade show d-block'
            id='kt_modal_add_user'
            role='dialog'
            tabIndex={-1}
            aria-modal='true'
          >
            {/* begin::Modal dialog */}
            <div className='modal-dialog modal-dialog-centered mw-650px'>
              {/* begin::Modal content */}
              <div className='modal-content'>
                <ViewModalHeader setID={props.setID} />
                {/* begin::Modal body */}
                <div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
                  <form className='form w-100' id='kt_login_signin_form' onSubmit={handleSubmit} >
                    {/* begin::Heading */}
                    <div className='text-center mb-5'>
                      <h1 className='text-marino f-titulo fs-md fw-bolder mb-3'>Create Device</h1>
                    </div>
                    {/* begin::Heading */}

                    {/* begin::Login options */}


                    {/* Campos solicitud */}
                    <div>
                      <label className='form-label fw-bolder text-marino f-parrafo fs-6 mb-0 required form-label'>Entitlement</label>
                      <select
                        required
                        id='Prioridad'
                        value={entitlement}
                        onChange={(e) => setentitlement(e.target.value)}

                        className="form-select form-select-solid  border-gray-300 f-parrafo " aria-label="Select example">
                        <option selected hidden>Select</option>
                        {Records.map((d: any, i: any) => (
                          <option key={i} value={d.id}>{d.name}</option>

                        ))}

                      </select>
                    </div>
                    <br />
                    <div>
                      <label className='form-label fw-bolder text-marino f-parrafo fs-6 mb-0 required' htmlFor="name">Name</label>
                      <input type="text"
                        required
                        name='name'
                        className='form-control border-gray-300 f-parrafo'
                        id='Nombre'
                        value={Nombre}
                        onChange={(e: any) => setNombre(e.target.value)}
                      />
                    </div>
                    <br />

                    <br />
                    <div className='row'>
                      <div className='col'>
                        <div className='col'>
                          <label className='form-label fw-bolder text-marino f-parrafo fs-6 mb-0' htmlFor="descripcion">VCPU</label>
                          <input type="text"
                            name='VCPU'
                            className='form-control border-gray-300 f-parrafo'
                            id='VCPU'
                            value={Vcpu}

                          />
                        </div>
                      </div>
                      <div className='col'>
                        <label className='form-label fw-bolder text-marino f-parrafo fs-6 mb-0 required' htmlFor="descripcion">RAM</label>
                        <select
                          required
                          id='Prioridad'
                          value={Memory}
                          onChange={(e) => setMemory(e.target.value)}
                          className="form-select form-select-solid border border-gray-300 f-parrafo " aria-label="Select example">
                          <option selected hidden>Select</option>
                          <option value={2}>2 GiB</option>
                          <option value={4}>4 GiB</option>


                        </select>
                      </div>

                      {/*<div className='col'>
                                   <label className='form-label fw-bolder text-marino f-parrafo fs-6 mb-0' htmlFor="descripcion">Memory</label>
                                      <input type="text" 
                                      name='Memory' 
                                      className='form-control border-marino' 
                                      id='Memory'
                                      value={GBRam}
                                 
                                      />                                   
                                          </div>*/}
                    </div>
                    <br />

                    {/* end::Label */}
                    {/* end::Radio */}

                    {/* begin::Action */}
                    <br />
                    {currentUser?.is_demo !== true && <div className='d-grid justify-content-center '>

                      <div className='row'>
                        <div className='col'>
                          <button
                            type='submit'
                            id='kt_sign_in_submit'
                            className='btn btn-primary'
                          >
                            {!loading && <span className='indicator-label'>Save</span>}
                            {loading && (
                              <span className='indicator-progress' style={{ display: 'block' }}>
                                Please wait...
                                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                              </span>
                            )}
                          </button>
                        </div>
                        <div className='col'>
                          <button
                            className='btn-cancel btn border border-pink text-pink f-parrafo'
                            style={{ width: '200px' }}
                            onClick={() => props.setID(undefined)}

                          >
                            Cancel
                          </button>
                        </div>
                      </div>


                    </div>}

                    {/* end::Action */}

                  </form>
                  {currentUser?.is_demo === true && <div className="d-flex justify-content-center">
                    <button onClick={() => setID(null)} type='submit' id='kt_sign_in_submit'
                    >Save</button>

                  </div>}
                </div>
                {/* end::Modal body */}
              </div>
              {/* end::Modal content */}
            </div>
            {/* end::Modal dialog */}
          </div>
          {/* begin::Modal Backdrop */}
          <div className='modal-backdrop fade show'></div>
          {/* end::Modal Backdrop */}
          {ID !== undefined && <DemoModal setID={setID} id={ID} />}

        </div>

      }


      {props.id === 'password' &&
        <div>
          <div
            className='modal fade show d-block'
            id='kt_modal_add_user'
            role='dialog'
            tabIndex={-1}
            aria-modal='true'
          >
            {/* begin::Modal dialog */}
            <div className='modal-dialog modal-dialog-centered mw-650px'>
              {/* begin::Modal content */}
              <div className='modal-content'>
                <ViewModalHeader setID={props.setID} />
                {/* begin::Modal body */}
                <div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
                  <form className='form w-100' id='kt_login_signin_form' onSubmit={handleSubmit} >
                    {/* begin::Heading */}
                    <div className='text-center mb-5'>
                      <h1 className='text-marni f-titulo fw-bolder mb-3'>Credentials</h1>
                    </div>
                    {/* begin::Heading */}

                    {/* begin::Login options */}


                    {/* Campos solicitud */}

                    <div>
                      <label className='form-label fw-bolder text-marino f-parrafo fs-6 mb-0 ' htmlFor="user">User</label>
                      <input type="text"
                        required
                        name='user'
                        className='form-control border-gray-300 f-parrafo'
                        id='user'
                        value={credentials.user}

                      />
                    </div>
                    <br />


                    <div>
                      <label className='form-label fw-bolder text-marino f-parrafo fs-6 mb-0' htmlFor="descripcion">Password</label>
                      <div className="input-group">
                        <input
                          type={showPassword ? 'text' : 'password'}
                          name='Password'
                          className='form-control border-gray-300 f-parrafo'
                          id='Password'
                          value={credentials.pass}
                        />
                        <button className="btn btn-outline-secondary border border-gray-300" type="button" onClick={handleTogglePassword}>
                          {showPassword ? <i className="bi bi-eye-slash"></i> : <i className="bi bi-eye"></i>}
                        </button>
                        <button className="btn btn-outline-secondary border border-gray-300" type="button" onClick={handleCopyPassword}>
                          <i className="bi bi-clipboard"></i>
                        </button>
                      </div>
                      {showCopyNotification && (
                        <div className="notification-popup f-parrafo text-pink">Your password has been copied!</div>
                      )}
                    </div>

                  </form>
                </div>
                {/* end::Modal body */}
              </div>
              {/* end::Modal content */}
            </div>
            {/* end::Modal dialog */}
          </div>
          {/* begin::Modal Backdrop */}
          <div className='modal-backdrop fade show'></div>
          {/* end::Modal Backdrop */}
        </div>
      }

    </>
  )
}
export { DevicesForti }